module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel panel-default panel-search"
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('el-select', {
    staticClass: "formitem-label",
    staticStyle: {
      "width": "120px"
    },
    model: {
      value: (_vm.dateRangeType),
      callback: function($$v) {
        _vm.dateRangeType = $$v
      },
      expression: "dateRangeType"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "activeOn",
      "label": "激活时间"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "useOn",
      "label": "使用时间"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "createOn",
      "label": "记录时间"
    }
  })], 1)], 1), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "使用状态"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": true
    },
    model: {
      value: (_vm.page.query.param.useStatus),
      callback: function($$v) {
        _vm.$set(_vm.page.query.param, "useStatus", $$v)
      },
      expression: "page.query.param.useStatus"
    }
  }, _vm._l((_vm.$dict.store.COUPON_STATUS), function(item) {
    return _c('el-option', {
      key: item[0],
      attrs: {
        "label": item[1],
        "value": item[0]
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "券号"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.page.query.param.sn),
      callback: function($$v) {
        _vm.$set(_vm.page.query.param, "sn", $$v)
      },
      expression: "page.query.param.sn"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    directives: [{
      name: "keycode",
      rawName: "v-keycode",
      value: ('ENTER'),
      expression: "'ENTER'"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "keycode",
      rawName: "v-keycode",
      value: ('ENTER'),
      expression: "'ENTER'"
    }],
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("导出")])], 1)], 1)], 1), _vm._v(" "), _c('v-table', {
    ref: "table",
    attrs: {
      "page": _vm.page,
      "table-minheight": 450
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sn",
      "label": "券号",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "batchNo",
      "label": "批次号",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n        [" + _vm._s(row.promotionInfo.name) + "]-" + _vm._s(row.promotionInfo.discountCondition) + "\n        "), _c('span', {
          staticStyle: {
            "color": "gray"
          }
        }, [_vm._v(_vm._s(row.promotionInfo.tip))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "activeOn",
      "label": "激活时间",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "endOn",
      "label": "截止时间",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dispatchChannelName",
      "label": "派发渠道",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "激活状态",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n        " + _vm._s(row.activeStatus == 0 ? '未激活' : '已激活') + "\n         "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (row.activeStatus),
            expression: "row.activeStatus"
          }]
        }, [_vm._v("[" + _vm._s(row.activeKey) + "]")]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!row.activeStatus),
            expression: "!row.activeStatus"
          }],
          attrs: {
            "type": "text",
            "icon": "el-icon-share",
            "title": "激活"
          },
          on: {
            "click": function($event) {
              return _vm.dispatch2User(row)
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "使用状态",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(_vm.$dict.getText(row.useStatus, _vm.$dict.store.COUPON_STATUS)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "使用用户",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(row.username))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "使用订单号",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(row.useOrderno))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createOn",
      "width": "140",
      "label": "创建时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(row.createOn))]
      }
    }])
  })], 1), _vm._v(" "), _c('v-dialog', {
    ref: "formDiag",
    attrs: {
      "title": "生成优惠券",
      "width": "500px"
    }
  }, [_c('form-panel', {
    on: {
      "saved": _vm.onFormSaved
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.formDiag.dispatch('submit')
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    ref: "dispatchFormDiag",
    attrs: {
      "title": "优惠券激活",
      "width": "500px"
    }
  }, [_c('dispatch-form-panel', {
    on: {
      "saved": _vm.onFormSaved2
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dispatchFormDiag.dispatch('submit')
      }
    }
  }, [_vm._v("确定激活")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1013fef5","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/act/promotionCoupon/Manage.vue
// module id = 312
// module chunks = 0